/* ============================================================
 * <lion-product-recommendations>
 * - Fetches /recommendations/products?section_id=X&product_id=Y
 *   when it scrolls near the viewport.
 * - Replaces its innerHTML with the fetched section markup so
 *   all progressive-enhancement custom elements (card-product,
 *   lion-quick-add-button) hydrate on their own.
 * ============================================================ */

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.url = this.dataset.url;
    this.loaded = false;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !this.loaded) this.load();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    observer.observe(this);
  }

  async load() {
    this.loaded = true;
    try {
      const res = await fetch(this.url);
      if (!res.ok) throw new Error(res.statusText);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const fresh = doc.querySelector('lion-product-recommendations');
      const section = doc.querySelector('.related-products');
      if (fresh && fresh.innerHTML.trim()) {
        this.innerHTML = fresh.innerHTML;
      } else if (section) {
        this.innerHTML = section.outerHTML;
      }
    } catch (err) {}
  }
}

if (!customElements.get('lion-product-recommendations')) {
  customElements.define('lion-product-recommendations', ProductRecommendations);
}
